<template>
  <div style="background-color: white">
  <div>
    <van-nav-bar title="审核列表" style="position:fixed;width: 100%;"  @click-left="onClickLeft" left-text="返回" left-arrow>
    </van-nav-bar>
    <div  style="padding-top: 45px">
      <van-tabs @click="onShClick">
        <van-tab title="未审" name="1"></van-tab>
        <van-tab title="已审" name="2"></van-tab>
        <van-tab title="申请" name="3"></van-tab>

      </van-tabs>
      <van-pull-refresh v-if="xzx==1" v-model="refreshing1" @refresh="onRefresh">
        <van-list
          v-model="loading1"
          :finished="finished1"
          finished-text="没有更多了"

          @load="onLoad"

        >

          <van-cell v-for="item in list1" :key="item.dataid" :value="dateformat(item.createTime,'YYYY-MM-DD')" :title="item.workdesc" is-link @click="zzpath(item)" />
        </van-list>
      </van-pull-refresh>
      <van-pull-refresh v-if="xzx==2" v-model="refreshing2" @refresh="onRefresh">
        <van-list
          v-model="loading2"
          :finished="finished2"
          finished-text="没有更多了"

          @load="onLoad"

        >

          <van-cell v-for="item in list2" :key="item.dataid" :title="item.workdesc" :value="dateformat(item.createTime,'YYYY-MM-DD')" is-link @click="zzpath(item)" />
        </van-list>
      </van-pull-refresh>
      <van-pull-refresh v-if="xzx==3" v-model="refreshing3" @refresh="onRefresh">
        <van-list
          v-model="loading3"
          :finished="finished3"
          finished-text="没有更多了"

          @load="onLoad"

        >

          <van-cell v-for="item in list3" :key="item.workid" :title="item.workdesc" :value="dateformat(item.createTime,'YYYY-MM-DD')" is-link @click="sqpath(item)" />
        </van-list>
      </van-pull-refresh>
    </div>
  </div>

  </div>
</template>

<script>
import {listdqsh, listysh, listsq} from '@/api/xm/shenhe'
export default {
  name: 'shlist',
  data () {
    return {
      list: [],
      list1: [],
      list2: [],
      list3: [],
      awflist: [],
      xzx: 1,
      ysws: 0,
      loading1: false,
      finished1: false,
      refreshing1: false,
      loading2: false,
      finished2: false,
      refreshing2: false,
      loading3: false,
      finished3: false,
      refreshing3: false,
      queryParams1: {
        pageNum: 1,
        pageSize: 10

      },
      queryParams2: {
        pageNum: 1,
        pageSize: 10

      },
      queryParams3: {
        pageNum: 1,
        pageSize: 10

      }

    }
  },
  created () {
    this.getActWorkData()

    this.getList()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    onShClick (name, title) {
      this.xzx = parseInt(name)
      this.getList()
    },
    dateformat (timestr, pattern) {
      if (timestr) { return this.$moment(timestr).format(pattern) }
    },
    getActWorkData () {
      let that = this
      this.$ajax.get('/xm/shenhe/awflist').then(function (res) {
        if (res.code == 200) {
          that.awflist = res.rows
          console.log('awflist', res, that.awflist)
        }
      })
    },
    zzpath (row) {
      console.log('row:', row)
      for (let i = 0; i < this.awflist.length; i++) {
        if (row.codeid == this.awflist[i].codeid) {
          if (this.awflist[i].workid == 1) {
            return this.$router.push({name: 'xshtsh', query: {dataid: row.dataid, workid: row.workid, dqlc: row.dqlc}})
          } else if (this.awflist[i].workid == 3) {
            return this.$router.push({name: 'cghtsh', query: {dataid: row.dataid, workid: row.workid, dqlc: row.dqlc}})
          } else if (this.awflist[i].workid == 6) {
            return this.$router.push({name: 'yssh', query: {dataid: row.dataid, workid: row.workid, dqlc: row.dqlc}})
          } else if (this.awflist[i].workid == 5) {
            return this.$router.push({name: 'hxsh', query: {dataid: row.dataid, workid: row.workid, dqlc: row.dqlc}})
          } else if (this.awflist[i].workid == 4) {
            return this.$router.push({name: 'kpsh', query: {dataid: row.dataid, workid: row.workid, dqlc: row.dqlc}})
          }
        }
      }
      // if(row.codeid == 16)this.$router.push({name:'xshtsh',query:{dataid:row.dataid,workid:row.workid}})
    },
    sqpath (row) {
      console.log('row:', row)
      return this.$router.push({name: 'shlmxc', query: {codeid: row.codeid, workid: row.workid, value: row.workdesc}})
    },
    onLoad () {
      if (this.xzx == 1) {
        this.queryParams1.pageNum += 1
      }
      if (this.xzx == 2) {
        this.queryParams2.pageNum += 1
      }
      if (this.xzx == 3) {
        this.queryParams3.pageNum += 1
      }
      this.getList()
    },
    onRefresh () {
      // 清空列表数据

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      // this.loading = true

      if (this.xzx == 1) {
        this.queryParams1.pageNum = 1
        this.list1 = []
        this.refreshing1 = false
      }
      if (this.xzx == 2) {
        this.queryParams2.pageNum = 1
        this.list2 = []
        this.refreshing2 = false
      }
      if (this.xzx == 3) {
        this.queryParams3.pageNum = 1
        this.list3 = []
        this.refreshing3 = false
      }
      this.getList()
    },
    getList () {
      this.loading = true
      if (this.xzx == 1) {
        this.loading1 = true
        listdqsh(this.queryParams1).then(res => {
          if (this.list1 && this.list1.length == 0) {
            this.list1 = res.rows
          } else { this.list1.concat(res.rows) }

          this.loading1 = false
          if (res.total < this.queryParams1.pageNum * this.queryParams1.pageSize) {
            this.finished1 = true
          }
        })
      } else if (this.xzx == 2) {
        this.loading2 = true
        listysh(this.queryParams2).then(res => {
          if (this.list2 && this.list2.length == 0) {
            this.list2 = res.rows
          } else { this.list2.concat(res.rows) }

          this.loading2 = false

          if (res.total < this.queryParams2.pageNum * this.queryParams2.pageSize) {
            this.finished2 = true
          }
        })
      } else if (this.xzx == 3) {
        this.loading3 = true
        listsq(this.queryParams3).then(res => {
          if (this.list3 && this.list3.length == 0) {
            this.list3 = res.rows
          } else { this.list3.concat(res.rows) }

          this.loading3 = false
          if (res.total < this.queryParams3.pageNum * this.queryParams3.pageSize) {
            this.finished3 = true
          }
        })
      }
    }

  }
}

</script>

<style  lang="scss" scoped>
  // 底部标签栏
  .van-tabbar{
  .van-tabbar-item{
  &.van-tabbar-item--active{
     color: #1989fa !important;
   }
  &:first-child,&:last-child{
                   color: #1989fa;
                   background-color: #ECEDFD;//rgba(1, 1, 1, .6)//#DFE0E6;
  .van-tabbar-item__icon{
    font-size: 1rem;
  }
  }
  &:nth-child(2){
     color: #fff;
     background-color: #1989fa;
  &.van-tabbar-item--active{
     color: #fff !important;
   }
  }
  }
  }
</style>



// WEBPACK FOOTER //
// src/views/ShenHe/shlist.vue